import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 100px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	gap: 10px;
	align-items: center;
	width: 320px;
`;

const StyledLevelSquare = styled.div<{ $side: 'left' | 'right' }>`
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	background-color: ${(props) =>
		props.$side === 'left' ? '#0085FF' : 'rgba(17, 19, 20, 0.95)'};
	border: 1px solid
		${(props) =>
			props.$side === 'left' ? 'transparent' : 'rgba(255, 255, 255, 0.1)'};

	${Text} {
		font-style: normal;
		font-weight: 700;
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
		transition: all 0.3s ease;
	}

	.xp-info-enter & {
		opacity: 0;
		transform: ${(props) =>
			props.$side === 'left'
				? 'translateX(120px) scale(0.3)'
				: 'translateX(-120px) scale(0.3)'};
	}

	.xp-info-enter-active & {
		opacity: 1;
		transform: translateX(0) scale(1);
		transition:
			opacity 0.4s ease-out 0.3s,
			transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s;
	}

	.xp-info-enter-done & {
		opacity: 1;
		transform: translateX(0) scale(1);
	}

	.xp-info-exit & {
		opacity: 1;
		transform: translateX(0) scale(1);
	}

	.xp-info-exit-active & {
		opacity: 0;
		transform: ${(props) =>
			props.$side === 'left'
				? 'translateX(120px) scale(0.3)'
				: 'translateX(-120px) scale(0.3)'};
		transition:
			opacity 0.3s ease-in,
			transform 0.3s ease-in;
	}
`;

const StyledLevelProgressContainer = styled.div`
	position: relative;
	z-index: 3;
	width: 240px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(17, 19, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transform-origin: center;

	.xp-info-enter & {
		opacity: 0;
		transform: translateY(-40px) scale(0, 0);
	}

	.xp-info-enter-active & {
		opacity: 1;
		transform: translateY(0) scale(1, 1);
		transition:
			opacity 0.4s ease-out,
			transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
	}

	.xp-info-enter-done & {
		opacity: 1;
		transform: translateY(0) scale(1, 1);
	}

	.xp-info-exit & {
		opacity: 1;
		transform: translateY(0) scale(1, 1);
	}

	.xp-info-exit-active & {
		opacity: 0;
		transform: translateY(-40px) scale(0, 0);
		transition:
			opacity 0.3s ease-in 0.3s,
			transform 0.3s ease-in 0.3s;
	}
`;

const StyledLevelProgress = styled.div<{ $noTransition?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	height: 24px;
	background: #0085ff;
	border-radius: 7px;
	transition: ${(props) => (props.$noTransition ? 'none' : 'width 0.8s ease')};
`;

const StyledLevelContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: rgba(255, 255, 255, 0.5);

		span {
			color: #ffffff;
			font-weight: 700;
			transition: all 0.8s ease;
		}
	}
`;

const StyledLevelProgressWrapper = styled.div`
	position: absolute;
	top: 2px;
	left: 2px;
	width: 234px;
	height: 24px;
`;

export {
	StyledContainer,
	StyledLevelContainer,
	StyledLevelProgress,
	StyledLevelProgressContainer,
	StyledLevelProgressWrapper,
	StyledLevelSquare,
};
